import { render, staticRenderFns } from "./PuckButton.vue?vue&type=template&id=11e57b2d&scoped=true&"
import script from "./PuckButton.vue?vue&type=script&lang=js&"
export * from "./PuckButton.vue?vue&type=script&lang=js&"
import style0 from "./PuckButton.vue?vue&type=style&index=0&id=11e57b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e57b2d",
  null
  
)

export default component.exports